// extracted by mini-css-extract-plugin
export default {"card_no_input":"Payment_card_no_input__7eyVS"};